import { useTranslation } from 'react-i18next';

import { errorCode } from '@/shared/api/errors';

import { Alert } from './primitives';

/**
 * What a refusal of the server says to a person: the text of its error code, or,
 * for a code the application has no words for (and for a failure that is not the
 * server's answer at all), that something went wrong.
 */
export function useErrorMessage(): (error: unknown) => string {
  const { t } = useTranslation('common');
  return (error) =>
    t(`errors.${errorCode(error) ?? 'unknown'}`, { defaultValue: t('errors.unknown') });
}

/** A failed request, said where it failed. Nothing while there is no error. */
export function ApiError({ error, className }: { error: unknown; className?: string }) {
  const message = useErrorMessage();
  if (!error) return null;
  return (
    <Alert tone="bad" live className={className}>
      {message(error)}
    </Alert>
  );
}
